<div class="sidebar-wrapper tertiary-bg-color">
  <div class="cbm-logo">
    <div class="cbm-content">
      <img src="assets/img/sidebar/CBM_navbar_logo.svg" class="cbmLogo" alt="cbm_logo">
    </div>
  </div>
  <div class="activeUser font-bold text-center primary-font-size" style="color: #171C8F;">
        <span style="color: #171C8F; font-family: 'TradeGothic_LT_Bold', sans-serif; font-size: 24px;">
          {{userName}}
        </span><br>
        <span style="font-family: 'HelveticaNeue-Regular', sans-serif; font-size: 13px; color: #797A7B;">
        Contractor
        </span>
  </div>
  <div class="top-divider"></div>
  <div class="items-container">
      <a class="sr"
         routerLink="/service-request/create">Create Service Request</a>
      <a class="pending"
         routerLink="/service-request/search">Pending Transactions</a>
      <a class="em"
         routerLink="/employee/search">Employee Management</a>
      <a class="reports"
         routerLink="/reports">Reports Management</a>
      <a class="history"
         routerLink="/service-request/transaction-history">Transaction History</a>
      <div class="spacer"></div>
      <a class="password"
         routerLink="/password">Change Password</a>
      <a class="logout" (click)="onClickLogout()">Log Out</a>
  </div>
</div>
